/**
 * Created by Aleksandr on 29.11.2022
 */

const Orangery = function (data) {
    cleverapps.EventEmitter.call(this);

    this.data = data;

    this.maximized = this.data.maximized || false;

    this.selected = undefined;
    this.selectedTab = this.data.preSelectedTab;
    this.buttonVisible = true;
    this.brushMode = false;
    this.brushSize = 1;
};

Orangery.prototype = Object.create(cleverapps.EventEmitter.prototype);
Orangery.prototype.constructor = Orangery;

Orangery.prototype.init = function () {
    this.data.init();
};

Orangery.prototype.getControlName = function () {
    return "Orangery";
};

Orangery.prototype.toggleButton = function () {
    this.buttonVisible = !this.buttonVisible;
    this.trigger("toggleButton");
};

Orangery.prototype.toggleView = function (visible) {
    this.trigger("toggleView", visible);
};

Orangery.prototype.isBrushModeAvailable = function () {
    return Boolean(this.data.brushMode);
};

Orangery.prototype.isBrushMode = function () {
    return this.brushMode;
};

Orangery.prototype.toggleBrushMode = function () {
    this.brushMode = !this.brushMode;
    this.trigger("toggleBrushMode");
};

Orangery.prototype.setBrushSize = function (size) {
    if (size >= 1) {
        this.brushSize = size;
        this.trigger("changeBrushSize");
    }
};

Orangery.prototype.getBrushSize = function () {
    return this.brushSize;
};

Orangery.prototype.getBrushDimensions = function () {
    return {
        width: Math.floor((this.brushSize + 1) / 2),
        height: Math.floor(this.brushSize / 2) + 1
    };
};

Orangery.prototype.getBrushShape = function () {
    const shape = [];
    const dims = this.getBrushDimensions();
    const offsetX = Math.floor((dims.width - 1) / 2);
    const offsetY = Math.floor((dims.height - 1) / 2);
    for (let dx = 0; dx < dims.width; dx++) {
        for (let dy = 0; dy < dims.height; dy++) {
            shape.push({ x: dx - offsetX, y: dy - offsetY });
        }
    }
    return shape;
};

Orangery.prototype.select = function (item, tab) {
    if (this.selected !== item) {
        if (this.selected) {
            this.selected.onSelectionChanged(false);
        }

        this.selected = item;
        this.selectedTab = tab;

        if (item) {
            item.onSelectionChanged(true);
        }

        this.trigger("selectionChanged", item);
        this.trigger("changeButton");
    }
};

Orangery.prototype.unselect = function (item) {
    if (this.selected === item) {
        this.selected = undefined;
        this.selectedTab = undefined;

        if (item) {
            item.onSelectionChanged(false);
        }

        this.trigger("selectionChanged");
        this.trigger("changeButton");
    }
};

Orangery.prototype.listTabs = function () {
    return this.data.tabs.filter((tab) => tab.rows.length).map((tab, i) => ({ id: i, ...tab }));
};

Orangery.prototype.getItemCode = function (item) {
    return this.data.getItemCode(item);
};

Orangery.prototype.onClick = function (item) {
    if (this.data.onClick) {
        return this.data.onClick(item, this.selected);
    }
};

Orangery.prototype.destructor = function () {
    if (this.data.clear) {
        this.data.clear();
    }
};
